// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3_sFi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__oqIlF","obliqueLine":"membershipbadge_obliqueLine__1pTtv"};